export default {
  splitButton: (instance) => ({
    icon: '<img src="/static/icons/icon-3.png" width="16">',
    class: 'apex-custom-button volta-icon-split',
    title: 'Split',
    // index: 0,
    click: function () {
      instance.options.chart.stacked = false;
      instance.options.chart.stackType = null;
      instance.filter.split = true;
      instance.isAggregateMode = false;
      instance.reload();
    },
  }),
  mergeButton: (instance) => ({
    icon: '',
    class: 'apex-custom-button icon-network',
    title: 'Aggrega',
    // index: 0,
    click: function () {
      instance.filter.split = false;
      instance.isAggregateMode = false;
      instance.reload();
    },
  }),
  eurButton: (instance) => ({
    icon: '<img src="/static/icons/icon-6.png" width="16">',
    title: 'Visualizza costi',
    class: 'apex-custom-button volta-icon-euro',
    // index: 3,
    click: function () {
      instance.filter.costs = true;
      instance.reload();
    },
  }),
  measuresButton: (instance) => ({
    icon: '<img src="/static/icons/icon-26.png" width="16">',
    title: 'Visualizza misure',
    class: 'apex-custom-button volta-icon-euro',
    // index: 3,
    click: function () {
      instance.filter.costs = false;
      instance.reload();
    },
  }),
  stackedButton: (instance) => ({
    icon: '<img src="/static/icons/chart-column-stacked.png" width="16">',
    title: 'Stacked',
    class: 'apex-custom-button',
    // index: 4,
    click: function () {
      instance.filter.split = false;
      instance.options.chart.stacked = true;
      instance.options.chart.stackType = null;
      instance.isAggregateMode = false;
      instance.reload();
    },
  }),
  stackedPercentButton: (instance) => ({
    icon: '<img src="/static/icons/icon-percent.png" width="16">',
    title: 'Stacked Percent',
    class: 'apex-custom-button',
    // index: 5,
    click: function () {
      instance.filter.split = false;
      instance.options.chart.stacked = true;
      instance.options.chart.stackType = '100%';
      instance.isAggregateMode = false;
      instance.reload();
    },
  }),
  unStackedButton: (instance) => ({
    icon: '<img src="/static/icons/chart-column.png" width="16">',
    title: 'Unstacked columns',
    class: 'apex-custom-button',
    // index: 4,
    click: function () {
      instance.filter.split = false;
      instance.options.chart.stacked = false;
      instance.options.chart.stackType = null;
      instance.isAggregateMode = false;
      instance.reload();
    },
  }),
  aggregateButton: (instance) => ({
    icon: '<img src="/static/icons/fx.png" style="width: 22px; height: 14px;">',
    title: 'Aggregate columns',
    class: 'apex-custom-button',
    // index: 4,
    click: function () {
      instance.filter.split = false;
      instance.options.chart.stacked = false;
      instance.options.chart.stackType = null;
      instance.isAggregateMode = !instance.isAggregateMode;
      instance.reload();
    },
  }),
  rollingButton: (instance) => ({
    icon: instance.isRolling ?
      '<img src="/static/icons/rolling-disable.svg" style="width: 25px; height: 25px;">'
      : '<img src="/static/icons/rolling.svg" style="width: 20px; height: 20px;">',
    title: 'Rolling',
    class: 'apex-custom-button',
    // index: 4,
    click: function () {
      instance.filter.split = false;
      instance.options.chart.stacked = false;
      instance.options.chart.stackType = null;
      instance.isAggregateMode = false;
      instance.isRolling = !instance.isRolling;
      instance.reload();
    },
  }),
};



// WEBPACK FOOTER //
// ./src/components/Charts/Types/Apex/line-buttons.js